import { apiClient } from '@/http/apiClient';
const rootPath = 'languages';

class LanguageService {
  
    public async getLanguages(): Promise<any> {
        return apiClient.get(`${rootPath}`);
    }
    
}

export default new LanguageService();